import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { ApiPartnerService } from '../../api/api-partner.service';

@Component({
  selector: 'app-singleview',
  templateUrl: './singleview.component.html',
  styleUrls: ['./singleview.component.css']
})
export class SingleviewComponent implements OnInit {

  ViewCustomer: any = {};
  actionHistory: any = [];
  listservices: any = [];
  liststb: any = [];
  stbcust: any = [];
  constructor(
	  private route: ActivatedRoute,
	  private router: Router,
	  public partnerService: ApiPartnerService
  ) { }

  ngOnInit() {
  	this.loadStart();
  }

  loadStart() {
    let id = this.route.snapshot.paramMap.get('id');
  	//alert(id);
  	this.loadCustomer(id);
  }

  loadCustomer(id: any) {
    return this.partnerService.GetSingleview(id).subscribe((output: any) => {
    console.log(output);
       this.ViewCustomer = output.data;
       this.listservices = output.data.services;
       this.liststb = output.data.stb;
       this.stbcust = output.data.stbcust;
       //this.actionHistory = output.data.customer.actionHistory;
    })
  }

}
